import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function AdminTickets() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("all");

  const load = () => {
    const url = status === "all" ? "/admin/tickets" : `/admin/tickets?status=${encodeURIComponent(status)}`;
    api.get(url).then((r) => setItems(r.data));
  };
  useEffect(() => { load(); }, [status]);

  const badge = (s) => {
    const map = { Open: "bg-blue-50 text-blue-700 border-blue-200", "Waiting on Customer": "bg-amber-50 text-amber-700 border-amber-200", Closed: "bg-slate-100 text-slate-600 border-slate-200" };
    return <Badge className={`rounded-md font-mono text-[10px] uppercase tracking-widest border ${map[s] || ""}`}>{s}</Badge>;
  };

  return (
    <div data-testid="admin-tickets-page">
      <div className="mb-6 flex items-center justify-between gap-3">
        <div>
          <div className="eyebrow mb-2">Support</div>
          <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Tickets</h1>
        </div>
        <div className="flex gap-1">
          {["all", "Open", "Waiting on Customer", "Closed"].map((s) => (
            <button key={s} onClick={() => setStatus(s)} className={`h-9 px-3 rounded-md text-xs border ${status === s ? "bg-slate-900 border-slate-900 text-white" : "bg-white border-slate-200 text-slate-700"}`}>{s === "all" ? "All" : s}</button>
          ))}
        </div>
      </div>

      <div className="border border-slate-200 rounded-md bg-white divide-y divide-slate-100">
        {items.length === 0 && <div className="p-12 text-center text-slate-500">No tickets.</div>}
        {items.map((t) => (
          <Link key={t.ticket_id} to={`/admin/tickets/${t.ticket_id}`} className="block p-5 hover:bg-slate-50" data-testid={`admin-ticket-${t.ticket_id}`}>
            <div className="flex items-center gap-2 mb-1">
              <span className="font-mono text-xs text-slate-500">{t.ticket_id}</span>
              {badge(t.status)}
              <span className="text-[10px] font-mono uppercase tracking-widest text-slate-400">{t.priority}</span>
            </div>
            <div className="text-sm text-slate-900">{t.subject}</div>
            <div className="text-xs text-slate-500 mt-0.5">{t.customer_name} · {t.customer_email} · {t.category}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
